/**
 * @see [StackOverflow]{@link https://stackoverflow.com/questions/4250364/how-to-trim-a-file-extension-from-a-string-in-javascript}
 */
function filenameWithoutExtension(string: string) {
  return string.replace(/\.[^/.]+$/, "");
}

export {filenameWithoutExtension};
